import { createFileRoute } from '@tanstack/react-router';
import { SSiteNew } from '@/screens/SSiteNew/SSiteNew';

export const Route = createFileRoute('/$orgId/sites/new')({
  component: SSiteNew,
});
